<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        userData.permissions['view_staff_attendance'] == 1 ||
          userData.permissions['staff_mgt'] == 1
      "
    >
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="my-2">
                <div class="row">
                  <b-form-group class="col-md-3" label="Term">
                    <v-select
                      :options="schoolterms"
                      placeholder="Select Term"
                      v-model="schoolterm"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-3" label="Year">
                    <v-select
                      :options="years"
                      placeholder="Select Year"
                      v-model="year"
                    ></v-select>
                  </b-form-group>
                  <div class="col-md-4 mt-md-4 mt-2 p-lg-0">
                    <b-button variant="primary" @click="FilterData()"
                      ><i class="mdi mdi-account-search"></i> Filter</b-button
                    >
                  </div>
                </div>
              </div>

              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Selected Yet</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(staff)="data">
                    {{ data.item.staff.full_name }}
                  </template>
                  <template #cell(schoolterm)="data">{{
                    data.item.schoolterm.name
                  }}</template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <span v-if="data.item.status == 1">
                        <router-link
                          :to="{
                            path: '/stafftimesheets',
                            query: { id: data.item.id },
                          }"
                          type="button"
                          class="btn-sm btn btn-success"
                        >
                          <i class="mdi mdi-clipboard-text"></i>
                          View</router-link
                        >
                        <!-- <b-button @click="edit(data.item.id)" type="button" class="btn-sm btn" variant="info" v-b-modal.end-attendance> <i class="mdi mdi-square-edit-outline"></i> Check Out </b-button> -->
                      </span>
                      <span v-else>
                        <!-- <router-link :to="{ path: '/stafftimesheets', query: { id: data.item.id }}" type="button" class="btn-sm btn btn-success"> <i class="mdi mdi-clipboard-text"></i> View</router-link> -->
                      </span>
                    </div>
                  </template>
                </b-table>
              </div>

              <b-modal
                id="edit-products"
                centered
                title="Capture Attendance"
                title-class="font-14"
                hide-footer
              >
                <form @submit.prevent="editproducts">
                  <div class="form-group mb-2">
                    <input v-model="id" type="hidden" />
                    <label> Staff </label
                    ><small style="color: red;"> {{ staff.cardnumber }} </small>
                    <v-select
                      :options="staffmembers"
                      placeholder="Select Staff"
                      v-model="staff"
                      label="full_name"
                    ></v-select>
                    <label> School Term</label>
                    <v-select
                      :options="schoolterms"
                      placeholder="Select Term"
                      v-model="schoolterm"
                      label="name"
                    ></v-select>
                    <label>Year</label>
                    <v-select
                      :options="years"
                      placeholder="Select Year"
                      v-model="year"
                    ></v-select>
                  </div>
                  <div class="form-group d-flex justify-content-end">
                    <b-button
                      type="button"
                      class="btn w-30"
                      variant="secondary"
                      @click="$bvModal.hide('edit-products')"
                      >Close</b-button
                    >
                    <b-button
                      type="submit"
                      class="btn ms-1 w-30"
                      variant="primary"
                      ><i class="fas fa-check-circle"></i> Checkin</b-button
                    >
                  </div>
                </form>
              </b-modal>

              <b-modal
                id="end-attendance"
                centered
                title="Checkout"
                title-class="font-14"
                hide-footer
              >
                <form @submit.prevent="endattendance">
                  <div class="form-group mb-2">
                    <input v-model="id" type="hidden" />
                  </div>
                  <div class="form-group d-flex justify-content-end">
                    <b-button
                      type="button"
                      class="btn w-30"
                      variant="secondary"
                      @click="$bvModal.hide('end-attendance')"
                      >Close</b-button
                    >
                    <b-button
                      type="submit"
                      class="btn ms-1 w-30"
                      variant="primary"
                      ><i class="fas fa-check-circle"></i> End</b-button
                    >
                  </div>
                </form>
              </b-modal>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view this Page.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
// import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  schooltermComputed,
  schooltermMethods,
  staffattendancesComputed,
  staffattendancesMethods,
  staffmemberComputed,
  staffmemberMethods,
} from "@/state/helpers";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Staff Attendance ",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: " Staff Attendance",
      items: [
        { text: "Dashboard", to: "/" },
        { text: " Staff Attendance", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "staff", label: "Staff Member", visible: true },
        { key: "schoolterm", label: "Term", visible: true },
        { key: "year", label: "Year ", visible: true },
        { key: "attendance_date", label: "Attendance date ", visible: true },
        { key: "checkin", label: "Checkin Time", visible: true },
        { key: "checkout", label: "Checkout Time", visible: true },
      ],
      id: "",
      name: "",
      staff: "",
      attendance_date: "",
      checkin: "",
      checkout: "",
      schoolterm: "",
      year: new Date().getFullYear(),
      loader: false,
    };
  },
  computed: {
    ...staffattendancesComputed,
    ...schooltermComputed,
    ...staffmemberComputed,
    List() {
      return this.staffattendances.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.staffattendances.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.staffattendances.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.FilterData();
    this.fetchSchoolTerms();
    this.fetchStaffattendances();
    this.fetchStaffMembers();
    this.TotalRows = this.staffattendances.length;
    this.isBusy = false;
    this.schoolterm = this.schoolterms.find((option) => option.active == 1);
  },
  methods: {
    ...staffattendancesMethods,
    ...schooltermMethods,
    ...staffmemberMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id) {
      this.id = id;
      this.$bvModal.show("end-attendance");
    },

    // async editproducts() {
    //   let formData = new FormData();
    //   formData.append("staff", this.staff.id);
    //   formData.append("schoolterm", this.schoolterm.id);
    //   formData.append("year", this.year);
    //   let url = "/staffcheckin";
    //   await axios.post(url, formData).then((response) => {
    //   if (response.status == 200) {
    //       this.fetchStaffattendances();
    //       this.$bvModal.hide('edit-products');
    //   }
    //   });
    // },
    async endattendance() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/staffattendance";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchStaffattendances();
          this.$bvModal.hide("end-attendance");
        }
      });
    },
    FilterData() {
      this.filterStaffAttendance({
        schoolterm: this.schoolterm.id,
        year: this.year,
      });
    },
  },
};
</script>
